<section class="hero-banner-container">
  <h2>{{ title }}</h2>
  <div class="separator"></div>
  <p>{{ description }}</p>
</section>
